// extracted by mini-css-extract-plugin
export default {"deletableItemsList":"DeletableItemsList_deletableItemsList__hvQ6S","deleteableItemsListItem":"DeletableItemsList_deleteableItemsListItem__cXbrF"};